import type { CroFeature } from "@/types/croFeature";

// Single source of truth for which features have synthetic preview-mode
// data wired up. Drives both the banner's route gating (PreviewBanner)
// and the CRO-feature splash bypass (useCroFeatureAccess). Adding a new
// preview-mode feature here is the only edit needed for both consumers
// to pick it up.
type PreviewModeFeature = {
  pathPrefix: string;
  // Set when the preview-mode feature corresponds to a CroFeature gated
  // by useCroFeatureAccess. Omit for preview-mode features outside that
  // flow (e.g. routes not represented in the CroFeature enum).
  croFeature?: CroFeature;
};

export const PREVIEW_MODE_FEATURES: readonly PreviewModeFeature[] = [
  { pathPrefix: "/web-analytics", croFeature: "web_analytics" },
  { pathPrefix: "/funnels", croFeature: "funnels" },
  { pathPrefix: "/surveys", croFeature: "surveys" },
  { pathPrefix: "/ai-chat", croFeature: "ai_chat" },
];

export const PREVIEW_MODE_PATH_PREFIXES: readonly string[] =
  PREVIEW_MODE_FEATURES.map((f) => f.pathPrefix);

export const PREVIEW_MODE_CRO_FEATURES: ReadonlySet<CroFeature> = new Set(
  PREVIEW_MODE_FEATURES.map((f) => f.croFeature).filter(
    (f): f is CroFeature => f !== undefined,
  ),
);

export function pathHasPreviewData(pathname: string): boolean {
  return PREVIEW_MODE_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix + "/"),
  );
}
